// ========================================================================
// stateMachineUIService.ts 내용 시작 (xstate/services 경로)
// ========================================================================
import { useTicket } from "@/composables/useTicket"
import type { ChatMessage, IChatService } from "@wowpress/state-machine" // 패키지에서 타입/인터페이스 import

export class FirebaseChatService implements IChatService {
  async send(message: string): Promise<void> {
    console.log("[Firebase Chat Service] Sending message:", message)
    const { addBotMessage, recentTicket, updateTicket } = useTicket()

    if (recentTicket.value?.id) {
      if (recentTicket.value.status === "chatbot_handling" || recentTicket.value.status === "open") {
        if (recentTicket.value.status === "open") {
          await updateTicket(recentTicket.value?.id, { status: "chatbot_handling" })
        }

        await addBotMessage(recentTicket.value?.id, message)
      } else {
        console.error("[Firebase Chat Service] Ticket is not in chatbot_handling status")
      }
    } else {
      console.error("[Firebase Chat Service] No ticket ID found")
    }
  }

  async sendMedia(url: string): Promise<void> {
    console.log("[Firebase Chat Service] Sending Media:", url)
    const { addBotMessage, recentTicket, updateTicket } = useTicket()
    if (recentTicket.value?.id) {
      if (recentTicket.value.status === "chatbot_handling" || recentTicket.value.status === "open") {
        if (recentTicket.value.status === "open") {
          await updateTicket(recentTicket.value?.id, { status: "chatbot_handling" })
        }

        await addBotMessage(recentTicket.value?.id, url)
      } else {
        console.error("[Firebase Chat Service] Ticket is not in chatbot_handling status")
      }
    } else {
      console.error("[Firebase Chat Service] No ticket ID found")
    }
  }
}

// ========================================================================
// stateMachineUIService.ts 내용 끝
// ========================================================================
